<template>
  <div>
    <div class="paas-upload-select" @click="handleClick">
      <input class="paas-upload-input" ref="paasUploadInput" type="file"
             @change="handleChange"
             :multiple="multiple"/>
      <slot></slot>
    </div>
    <div class="paas-upload-list" v-for="item in files" :key="`file${item.id}`">
      <div class="paas-upload-show-file" v-if="format(item.filename) === 'ios-image'">
        <img :src="item.originalUrl" class="show-upload-file" @click="showUploadFileDetail(item)">
      </div>
      <div class="paas-upload-show-file" v-else-if="format(item.filename) === 'ios-film'">
        <video :src="item.originalUrl" class="show-upload-file" controls @click="showUploadFileDetail(item)"></video>
      </div>
      <div class="paas-upload-show-file" v-else-if="format(item.filename) === 'ios-musical-notes'">
        <audio :src="item.originalUrl" class="show-upload-file" @click="showUploadFileDetail(item)"></audio>
      </div>
      <div class="paas-upload-show-file" v-else-if="format(item.filename) === 'md-document'">
        <img src="./image/doc.png" class="show-upload-file" @click="showUploadFileDetail(item)"/>
      </div>
      <div class="paas-upload-show-file" v-else-if="format(item.filename) === 'ios-document'">
        <img src="./image/pdf.png" class="show-upload-file" @click="showUploadFileDetail(item)"/>
      </div>
      <div class="paas-upload-show-file" v-else-if="format(item.filename) === 'ios-stats'">
        <img src="./image/xls.png" class="show-upload-file" @click="showUploadFileDetail(item)"/>
      </div>
      <div class="paas-upload-show-file" v-else-if="format(item.filename) === 'ios-videocam'">
        <img src="./image/ppt.png" class="show-upload-file" @click="showUploadFileDetail(item)"/>
      </div>
      <div class="paas-upload-show-file" v-else>
        <Icon :type="format(item.filename)" @click="showUploadFileDetail(item)"></Icon>
      </div>
      <div class="file-name" :title="item.filename">{{item.filename}}</div>
      <div class="paas-upload-list-cover">
        <Icon type="ios-eye-outline" @click.native="handleView(item.originalUrl)"></Icon>
        <Icon type="ios-trash-outline" @click.native="deleteUploadFile(item)"></Icon>
      </div>
    </div>
    <div class="paas-upload-list" v-for="item in waitUploadFiles" :key="`file${item.id}`">
      <template v-if="item.status === 'finished'">
        <div class="paas-upload-show-file" v-if="format(item.file.name) === 'ios-image'">
          <img :src="item.data" class="show-upload-file">
        </div>
        <div class="paas-upload-show-file" v-else-if="format(item.file.name) === 'md-document'">
          <img src="./image/doc.png" class="show-upload-file"/>
        </div>
        <div class="paas-upload-show-file" v-else-if="format(item.file.name) === 'ios-document'">
          <img src="./image/pdf.png" class="show-upload-file"/>
        </div>
        <div class="paas-upload-show-file" v-else-if="format(item.file.name) === 'ios-stats'">
          <img src="./image/xls.png" class="show-upload-file"/>
        </div>
        <div class="paas-upload-show-file" v-else-if="format(item.file.name) === 'ios-videocam'">
          <img src="./image/ppt.png" class="show-upload-file"/>
        </div>
        <div class="paas-upload-show-file" v-else>
          <Icon :type="format(item.file.name)"></Icon>
        </div>
        <div class="file-name" :title="item.file.name">{{item.file.name}}</div>
        <div class="paas-upload-list-cover">
          <Icon type="ios-eye-outline" @click.native="handleView(item.file.name)"></Icon>
          <Icon type="ios-trash-outline" @click.native="deleteWaittingUploadFile(item)"></Icon>
        </div>
      </template>
      <template v-else>
        <Progress :percent="item.progress" :stroke-width="8" />
      </template>
    </div>
    <Modal title="图片预览" v-model="visible">
      <img :src="viewPic" v-if="visible" style="width: 100%">
    </Modal>
  </div>
</template>

<script>
  import $ from 'jquery';
  import { VueCropper }  from 'vue-cropper'
  // 分片大小
  const fileShardSize = 100 * 1024;
  /*const imageType = ['gif','jpg','jpeg','png','bmp','webp'];*/

  export default {
    name: "file-upload",
    model: {
      prop: 'files',
      event: 'change'
    },
    components: {
      VueCropper
    },
    data() {
      return {
        waitUploadFiles: [],
        operStatus: false,
        waitImageId: [],
        visible:false,
        viewPic:""
      }
    },
    props: {
      multiple: {
        type: Boolean,
        default: false
      },
      action: {
        type: String,
        default: ""
      },
      param: {
        type: Object,
        default() {
          return {};
        }
      },
      type: {
        type: Array,
        default () {
          return [];
        }
      },  //限定上传文档类型
      fileBusinessId: {
        type: String,
        default: ""
      },
      files: {
        type: Array,
        default() {
          return [];
        }
      }
    },
    watch:{
      files:{
        immediate:true, //immediate如果为true 代表如果在 wacth 里声明了之后，就会立即先去执行里面的handler方法
        handler: function (newval, oldval) {
        },
        deep: true
      }
    },
    methods: {
      handleClick () {
        this.$refs.paasUploadInput.click();
      },
      handleChange (e) {
        const files = e.target.files;
        if (!files) {
          return;
        }
        if(!this.multiple && (this.files.length > 0 || this.waitUploadFiles.length > 0)) {
          this.$Message.info('您已上传一个文件，请先删除！');
        }
        else {
          //上传
          this.uploadFiles(files);
        }
        this.$refs.paasUploadInput.value = null;
      },
      uploadFiles(files) {
        let types = this.type;
        let names = [];
        if(types && types.length > 0) {
          for(let i = 0; i < files.length; i++) {
            let fileName = files[i].name;
            let fileNames = fileName.split(".");
            let suffix = fileNames[fileNames.length - 1].toLowerCase();
            let exist = false;
            for(let n = 0; n < types.length; n++) {
              if(types[n].toLowerCase() === suffix) {
                exist = true;
                break;
              }
            }
            if(!exist) {
              names.push(fileName);
            }
            else {
              let id = this.fileBusinessId+""+new Date().getTime()+""+parseInt(10000000*Math.random());
              let size = files[i].size;
              let shardCount = Math.ceil(size / fileShardSize);
              let data = "";
              this.waitUploadFiles.push({id: id, index: 1, total: shardCount, progress:0, file: files[i], status: 'waitting', data: data});
              if(this.format(files[i].name) === "ios-image") {
                this.waitImageId.push(id);
              }
              // 检查是否有数据在上传
              if(this.waitUploadFiles[0].status === 'waitting') {
                this.upload();
              }
            }
          }
          if(this.waitImageId.length > 0) {
            this.showImg();
          }
          if(names.length > 0) {
            this.$emit("type-match", names);
          }
        }
        else {
          for(let i = 0; i < files.length; i++) {
            let id = this.fileBusinessId+""+new Date().getTime()+""+parseInt(10000000*Math.random());
            let size = files[i].size;
            let shardCount = Math.ceil(size / fileShardSize); //总块数
            let data = "";
            this.waitUploadFiles.push({id: id, index: 1, total: shardCount, progress:0, file: files[i], status: 'waitting', data: data});
            if(this.format(files[i].name) === "ios-image") {
              this.waitImageId.push(id);
            }
            // 检查是否有数据在上传
            if(this.waitUploadFiles[0].status === 'waitting') {
              this.upload();
            }
          }
          if(this.waitImageId.length > 0) {
            this.showImg();
          }
        }
      },
      showImg() {
        if(this.waitImageId.length === 0) {
          return ;
        }
        let firstIndex = 0;
        for(let m = 0; m < this.waitUploadFiles.length; m++) {
          if(this.waitUploadFiles[m].id === this.waitImageId[0]) {
            firstIndex = m;
            break;
          }
        }
        let that = this;
        let reader=new FileReader();
        reader.readAsDataURL(this.waitUploadFiles[firstIndex].file);
        reader.onload=function(){
          if(that.waitImageId.length === 0) {
            return ;
          }
          let imgData = reader.result;
          that.waitImageId.splice(0, 1);
          that.waitUploadFiles[firstIndex].data = imgData;
          that.showImg();
        }
      },
      upload() {
        if (this.waitUploadFiles.length > 0) {
          this.waitUploadFiles[0].status = "uploading";
          let start = (this.waitUploadFiles[0].index - 1) * fileShardSize,
            end = Math.min(this.waitUploadFiles[0].file.size, start + fileShardSize);
          let formData = this.jsonParamToFormData(this.param);
          formData.append("filename", this.waitUploadFiles[0].file.name);
          formData.append("file", this.waitUploadFiles[0].file.slice(start,end));
          formData.append("dataAttacheId", this.waitUploadFiles[0].id);
          formData.append("chunkNumber", this.waitUploadFiles[0].index);
          formData.append("totalChunks", this.waitUploadFiles[0].total);
          formData.append("sliceSize", fileShardSize);
          formData.append("totalSize", this.waitUploadFiles[0].file.size);
          let startTime = new Date().getTime();
          let that = this;
          $.ajax({
            url: this.action,
            type: "POST",
            data: formData,
            processData: false,  //很重要，告诉jquery不要对form进行处理
            contentType: false,  //很重要，指定为false才能形成正确的Content-Type
            dataType: 'json',
            success: function (res) {
              //;
              let endTime = new Date().getTime();
              let nextIndex = that.waitUploadFiles[0].index + 1;
              let progress = Math.ceil(that.waitUploadFiles[0].index * 100.0 / that.waitUploadFiles[0].total);
              let speedDw = "KB/S";
              let speed = (((end - start) / 1024.0) / ((endTime - startTime) / 1000.0)).toFixed(1);
              if (speed > 1024) {
                speed = (speed / 1024.0).toFixed(2);
                speedDw = "M/S";
              }

              //console.log(that.waitUploadFiles[0].file.name+"upload index=" + that.waitUploadFiles[0].index+"--progress:"+progress);
              // 已传完当前文件
              if (nextIndex > that.waitUploadFiles[0].total) {
                that.waitUploadFiles.shift(); //用于把数组的第一个元素从其中删除，并返回第一个元素的值。
                that.files.push(res.data.data);
                that.$emit("change", that.files);
              }
              // 当前文件未传完
              else {
                that.waitUploadFiles[0].index = that.waitUploadFiles[0].index + 1;
                that.waitUploadFiles[0].progress = progress;
                //console.log(that.waitUploadFiles[0].progress);
              }
              that.upload();
            },
            error: function () {
              that.$Message.error('数据加载失败，请重试！');
              that.upload();
            }
          });
        }
      },
      format (fileName) {
        let type = 'ios-image';
        if(fileName && fileName !== '' && fileName != null && fileName !== 'null' && typeof fileName !== "undefined") {
          const format = fileName.split('.').pop().toLocaleLowerCase() || '';
          if (['gif','jpg','jpeg','png','bmp','webp'].indexOf(format) > -1) {
            type = 'ios-image';
          }
          else if (['mp4','m3u8','rmvb','avi','swf','3gp','mkv','flv'].indexOf(format) > -1) {
            type = 'ios-film';
          }
          else if (['mp3','wav','wma','ogg','aac','flac'].indexOf(format) > -1) {
            type = 'ios-musical-notes';
          }
          else if (['doc','docx'].indexOf(format) > -1) {
            type = 'md-document';
          }
          else if (['pdf'].indexOf(format) > -1) {
            type = 'ios-document';
          }
          else if (['numbers','csv','xls','xlsx'].indexOf(format) > -1) {
            type = 'ios-stats';
          }
          else if (['keynote','ppt','pptx'].indexOf(format) > -1) {
            type = 'ios-videocam';
          }
          else {
            type = 'ios-document-outline';
          }
        }
        return type;
      },
      deleteWaittingUploadFile(id) {
        if(this.waitUploadFiles.length > 0) {
          for(let i = 0; i < this.waitUploadFiles.length; i++) {
            if(id === this.waitUploadFiles[i].id) {
              this.waitUploadFiles.splice(i, 1);
              break;
            }
          }
        }
      },
      deleteUploadFile(file) {
        let that = this;
        this.axios.get(this.$store.state.sysApi+"/sys/file/deleteFile?fileId="+file.id).then(function(res) {
          for(let i = 0; i < that.files.length; i++) {
            if(that.files[i].id === file.id) {
              that.files.splice(i, 1);
              that.$Message.info('数据删除成功！');
            }
          }
          that.$emit("change", that.files);
        }).catch(function(error) {
          that.$Message.info('数据删除失败，请重试！');
        });
      },
      showUploadFileDetail(file) {
        this.$emit("show-detail", file);
      },
      jsonParamToFormData(json){
        let formdata = new FormData();
        let obj;
        for(let key in json) {
          obj = json[key];
          if(Array.isArray(obj) && obj) {
            if(obj.length === 0) {
              continue;
            }
            if(typeof obj[0] === 'object') {
              for(let i = 0; i < obj.length; i++) {
                for(let k in obj[i]) {
                  formdata.append(key+'['+i+'].'+k, obj[i][k]);
                }
              }
            }
            else {
              formdata.append(key, json[key].toString());
            }
          }
          else {
            formdata.append(key, json[key]);
          }
        }
        return formdata;
      },
      /**
       * 预览
       * @param url
       */
      handleView(url){
        this.visible = true;
        this.viewPic = url
      }
    }

  }
</script>

<style scoped>
  .paas-upload-input {
    display: none;
  }
  /*附件样式*/
  .paas-upload-list{
    display:inline-block;
    height:160px;
    text-align: center;
    border:1px solid transparent;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    background: #FFFFFF;
    position:relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right:4px;
    margin-top:10px;
    min-width:160px;
    vertical-align: middle;
  }

  .paas-upload-list > .paas-upload-show-file > img,
  .paas-upload-list > .paas-upload-show-file > video,
  .paas-upload-list > .paas-upload-show-file > audio{
    height:130px;
  }
  .paas-upload-list > .ivu-progress{
    padding-top: 50px;
  }
  .paas-upload-list-cover{
    display:none;
    position:absolute;
    top:0;
    bottom: 0;
    left:0;
    right:0;
    background: rgba(0,0,0,.6);
  }
  .paas-upload-list:hover .paas-upload-list-cover{
    display:block;
  }
  .paas-upload-list-cover i{
    color:#FFFFFF;
    font-size: 40px;
    cursor: pointer;
    margin:50px 2px;
  }
  .paas-upload-list .file-name{
    position:absolute;
    height: 30px;
    color: black;
    width:100%;
    bottom:0;
  }
</style>
